import { useAppDispatch, useAppSelector } from "../app/app.store";
import { selectAuth, userLoggedOut } from "../app/features/auth/auth.slice";

export default function useAuth() {
  const auth = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();

  const isAuthenticated = !!auth.accessToken;

  const logout = () => {
    dispatch(userLoggedOut());
    window.location.reload();
  };

  return { ...auth, isAuthenticated, logout };
}
